<template>
    <v-sheet>
        <questions v-model="questions" v-bind="value" @input="storeQuestions" />
        <div class="v-btn-group flex-wrap">
            <v-btn outlined color="grey-d" class="min-w-140px min-w-lg-160px" @click="$emit('prev')"><span class="grey-6--text">이전으로</span></v-btn>
            <v-btn outlined color="grey-d" class="min-w-140px min-w-lg-160px" @click="save()"><span class="grey-6--text">임시저장</span></v-btn>
            <v-btn color="primary" class="min-w-140px min-w-lg-160px" @click="save(COMPLETED.value)"><span>저장 후 다음으로</span></v-btn>
        </div>
        <!-- <v-row justify="center" class="ma-0 mt-40">
            <v-col cols="auto" class="pa-4"> <v-btn large outlined color="#666" @click="$emit('prev')">이전으로</v-btn> </v-col>
            <v-col cols="auto" class="pa-4"> <v-btn large outlined color="#666" @click="save()">임시저장</v-btn> </v-col>
            <v-col cols="auto" class="pa-4"> <v-btn large color="primary" @click="save(COMPLETED.value)">저장 후 다음으로</v-btn> </v-col>
        </v-row> -->
    </v-sheet>
</template>

<script>
import api from "@/api";
import { APPLICATION_STATES, APPLICATION_WRITIG_STEPS } from "@/assets/variables";
import Questions from "./questions.vue";

const state = APPLICATION_STATES.ON_WRITING.value;
const { QUESTIONS, COMPLETED } = APPLICATION_WRITIG_STEPS;

export default {
    components: {
        Questions,
    },
    props: {
        value: { type: Object, default: () => ({}) }, // form
        formResume: { type: Function, default: () => () => {} },
    },
    data: () => ({
        questionStorage: [],
        questions: [],

        COMPLETED,
    }),
    computed: {
        isCreate() {
            return !this.value?._id;
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.questions = [...(this.value?.questions || [])];
        },
        emit() {
            this.$emit("input", { ...this.value, questions: [...(this.questions || [])] });
        },
        async save(writingStep = QUESTIONS.value) {
            if(!this.validation()) return ;

            let { questions } = this;
            let { _recruitment } = this.value;
            let { post, put } = api.v1.recruitments.application;
            const { application } = await (this.isCreate ? post : put)({ _recruitment, questions, state, writingStep });
            application.resume = this.formResume(application.resume);
            this.$emit("input", application);

            alert("저장되었습니다");
        },
        validation(){
            for(let i = 0; i < this.questionStorage.length; i++){
                if(!this.questionStorage[i].response){
                    alert("모든 질문에 답변해주세요");
                    return;
                }
            }
            return true;
        },
        storeQuestions(value){
            this.questionStorage = value
        }
    },
};
</script>
